<script lang="ts">
  // data
  import {
    patronMenuDrawerOpen,
    menuDrawerOpen,
    breakpoint,
    mobileView,
    scrollDisabled,
    scrollBarWidth,
    show_confetti,
    header_hiding,
    colors,
    activeColor,
  } from "$lib/data";

  // close the modal overlay on naviagation
  import { navigating } from "$app/stores";
  import { browser } from "$app/environment";
  $: if (browser && $navigating) {
    $menuDrawerOpen = false;
    $show_confetti = false;
    $header_hiding = false;
  }
  // styles
  import "$lib/styles/normalize.css";
  import "$lib/styles/app.css";
  import "$lib/styles/vars.css";
  import "$lib/styles/fonts.css";

  // layout components
  import Header from "$lib/components/layout/header/Header.svelte";
  import { Toaster } from "svelte-french-toast";
  import Mobile from "$lib/components/layout/header/navigation/Mobile.svelte";
  import MobilePatron from "$lib/components/layout/header/navigation/MobilePatron.svelte";
  import Footer from "$lib/components/layout/footer/Footer.svelte";
  import FullScreenConfetti from "$components/layout/FullScreenConfetti.svelte";
  import BackgroundBar from "$lib/components/layout/page/BackgroundBar.svelte";
  import ScrollDisable from "$lib/components/layout/page/ScrollDisable.svelte";
  import { init_web_socket, ws, ws_status } from "$lib/websockets/connection";
  import { logging_in_spinner } from "$lib/data";

  let browserWidth: number;

  $: if (browser) $mobileView = browserWidth <= $breakpoint;

  // intro art && make sure header isnt hidden
  import { write_intro } from "$lib/intro_log";
  import { onMount, onDestroy } from "svelte";
  import MobileMember from "$components/layout/header/navigation/MobileMember.svelte";
  export let data;

  onMount(async () => {
    $header_hiding = false;
    $logging_in_spinner = false;
    write_intro();

    // we need to check to see if we have a websocket connection
    // if we don't have a token, we need to get one
    // we also need a valid token to connect, so we will check for that too
    if ($ws_status !== "connected") {
      let token = data.access_token;
      // ok, we need to connect, lets check for a token
      if (!token && data.user?.id) {
        // we need to get our access token from the server
        const new_token: { token: string } = await (
          await fetch("/members/downloads/token")
        ).json();
        token = new_token.token;
        $ws = init_web_socket(token, data.should_refresh_token ?? true);
      } else if (token) {
        $ws = init_web_socket(token, data.should_refresh_token ?? true);
      } else {
        // we don't have a token, so we can't connect
        // we will just return
        console.log("cannot connect to websocket, no token or user id");
        return;
      }
    }
  });

  onDestroy(() => {
    if ($ws) {
      $ws.close();
    }
  });
</script>

<svelte:head>
  <script
    defer
    src="https://stats.craftroulette.live/script.js"
    data-website-id="20dccda9-259d-45a2-b490-cb36011fa733"
  ></script>
</svelte:head>

<svelte:window bind:innerWidth={browserWidth} />

<!-- site -->
<Toaster />
<Header />
<BackgroundBar />
<div
  class="layout"
  style:padding-right="{$scrollDisabled
    ? browserWidth > 768
      ? $scrollBarWidth
      : 0
    : 0}px"
  style="
        --primary: {colors[$activeColor].color};
        --secondary: {colors[$activeColor].highlight};
    "
>
  <slot />
</div>
<Footer />
<ScrollDisable />

{#if data.user?.id && $mobileView}
  <MobileMember />
{/if}

<!-- conditional views -->
{#if $menuDrawerOpen}
  <Mobile />
{/if}

{#if $patronMenuDrawerOpen}
  <MobilePatron />
{/if}

{#if $show_confetti}
  <FullScreenConfetti />
{/if}
